import { env } from '~/app/environment'
import { isPromoBannerEligibleDevice } from '~/shared/helpers/appOpen'

const firebaseDevConfig = {
  apiKey: 'AIzaSyDA9DMcpGXzPeZ2hNzLLPCrowFqf-fHow0',
  authDomain: 'uvotv-all-website-data.firebaseapp.com',
  projectId: 'uvotv-all-website-data',
  storageBucket: 'uvotv-all-website-data.appspot.com',
  messagingSenderId: '743012131049',
  appId: '1:743012131049:web:8c83c27cdfe10516649078',
  measurementId: 'G-857N02Y38J',
}

// A/B testing OVP-2711: split configs for mobile/desktop devices (isPromoBannerEligibleDevice)
// https://setplexapps.atlassian.net/browse/OVP-2711
const firebaseDevMobileConfig = {
  apiKey: 'AIzaSyBW_I6fPst41faLHe3GsXYCiXZ4OxaEDF0',
  authDomain: 'uvotv-all-website-data.firebaseapp.com',
  projectId: 'uvotv-all-website-data',
  storageBucket: 'uvotv-all-website-data.appspot.com',
  messagingSenderId: '743012131049',
  appId: '1:743012131049:web:5da3c3494022f017649078',
  measurementId: 'G-YP0Q0PTY4N',
}

const firebaseProdConfig = {
  apiKey: 'AIzaSyDA9DMcpGXzPeZ2hNzLLPCrowFqf-fHow0',
  authDomain: 'uvotv-all-website-data.firebaseapp.com',
  projectId: 'uvotv-all-website-data',
  storageBucket: 'uvotv-all-website-data.appspot.com',
  messagingSenderId: '743012131049',
  appId: '1:743012131049:web:b616aeb9e0f7ab92649078',
  measurementId: 'G-TTP4Y9DPFL',
}

// A/B testing OVP-2711: split configs for mobile/desktop devices (isPromoBannerEligibleDevice)
// https://setplexapps.atlassian.net/browse/OVP-2711
const firebaseProdMobileConfig = {
  apiKey: 'AIzaSyBW_I6fPst41faLHe3GsXYCiXZ4OxaEDF0',
  authDomain: 'uvotv-all-website-data.firebaseapp.com',
  projectId: 'uvotv-all-website-data',
  storageBucket: 'uvotv-all-website-data.appspot.com',
  messagingSenderId: '743012131049',
  appId: '1:743012131049:web:32930608e6ee0316649078',
  measurementId: 'G-PGWKB4PG3W',
}

function getFirebaseConfig() {
  if (env.UVO_FIREBASE_CONFIG === 'production') {
    return isPromoBannerEligibleDevice()
      ? firebaseProdMobileConfig
      : firebaseProdConfig
  }
  return isPromoBannerEligibleDevice()
    ? firebaseDevMobileConfig
    : firebaseDevConfig
}

export const firebaseConfig = getFirebaseConfig()
